module.exports = __webpack_public_path__ + "img/logo.a018e5fe.jpeg";